module.exports = __webpack_public_path__ + "static/media/module_home_quiz.dfd3a81d.png";